// src/components/AppComponents/Sidebar/CustomerMenu/CustomerMenuItem.tsx

import { TUserRole } from '@/shared/types/user';
import i18n from '@/shared/i18n/i18n';
import { cx } from '@/components/UI/lib/utils';

interface CustomerMenuItemProps {
  name: string;
  role: TUserRole;
  className?: string;
}
const CustomerMenuItem: React.FC<CustomerMenuItemProps> = ({
  name,
  role,
  className,
}) => {
  return (
    <span className={cx('flex flex-col items-start', className)}>
      <span className="text-left text-revving-content font-accent truncate w-full">
        {name}
      </span>
      {role && (
        <span className="text-xs text-revving-content-subtle dark:text-darkRevving-content-subtle font-normal">
          {i18n.t(`generic.userRoles.${role}`) || ''}
        </span>
      )}
    </span>
  );
};

export default CustomerMenuItem;
